

















































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ImageFile } from '@/types/image'
import { ImageFilePayload } from '@/api/image/types'
import FileInput from '@/components/common/inputs/FileInput.vue'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  },
  filters: {
    formatDate(dateString: string) {
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  }
})
export default class ImageUpload extends Vue {
  $store!: ExStore
  image: ImageFile | null = null
  base64 = ''
  fileSelect = false
  loading = false

  get patientId() {
    return Number(this.$route.params.patientId)
  }

  get imageId() {
    return Number(this.$route.params.imageId)
  }

  async fetchImage() {
    try {
      const res = await this.$api.image.fetchOne({
        patientId: this.patientId,
        imageId: this.imageId
      })
      this.image = res
    } catch (e) {
      if (e.message === 'Not Found') {
        this.$router.replace({ name: 'DocumentTabIndex' })
      }
    }
  }

  async upload() {
    this.loading = true
    try {
      const payload: Partial<ImageFilePayload> = {
        title: this.image?.title,
        description: this.image?.description,
        fileName: this.image?.fileName
      }

      if (this.base64) {
        payload.fileContent = this.base64
      }

      await this.$api.image.patch({
        patientId: this.patientId,
        imageId: this.imageId,
        payload
      })
      this.$router.push({
        name: 'ImageTabIndex'
      })
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }

  async created() {
    await this.fetchImage()
  }
}
